import { httpGatewayService } from "@/modules/common/services";

const IS_TYPING = 'business/messaging/v1/channels/typing';

const businessIsTyping = params => httpGatewayService.post(IS_TYPING, params);

export default {
  businessIsTyping
}
